import React, { useState, useEffect } from "react"
import { Container, Col, Row } from "react-bootstrap"
import DeliveryPage from "../../Components/Admin/AdminReservation"
import MobileDineInPage from "../../Components/Admin/MobileDineinOrders"
const AdminReservation = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768)
    }

    // Perform an initial check
    handleResize()

    // Listen for resize events
    window.addEventListener("resize", handleResize)

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])
  return (
    <Container fluid className="px-0">
      <Col
        lg="10"
        sm="12"
        className="px-0"
        style={{ marginLeft: isMobile ? "0" : "17%" }}
      >
        {isMobile ? <MobileDineInPage /> : <DeliveryPage />}
      </Col>
    </Container>
  )
}
export default AdminReservation
